import React, { useState } from "react";
import PageLayout from "./PageLayout ";
import { api_url } from "../../url";
import { toast } from "react-toastify";

export default function JoinVolunteer() {
  const initialState = {
    name: "",
    email: "",
    phone: "",
    location: "",
    address: "",
    role: "",
    qualification: "",
    linkedin: "",
    availability: "",
    duration: "",
    activity: "",
    personality: "",
    motivation: [],
    causes: [],
    org: "",
    duration2: "",
    role2: "",
    cv: null,
  };
  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => {
        const list = prev[name] || [];
        return {
          ...prev,
          [name]: checked
            ? [...list, value]
            : list.filter((item) => item !== value),
        };
      });
    } else {
      setFormData({
        ...formData,
        [name]: files ? files[0] : value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const form = new FormData();

      // 🔹 Normal fields
      form.append("name", formData.name);
      form.append("email", formData.email);
      form.append("phone", formData.phone);
      form.append("location", formData.location);
      form.append("address", formData.address);
      form.append("role", formData.role);
      form.append("qualification", formData.qualification);
      form.append("linkedin", formData.linkedin);
      form.append("availability", formData.availability);
      form.append("duration", formData.duration);
      form.append("activity", formData.activity);
      form.append("personality", formData.personality);

      // 🔹 Arrays → string
      form.append("motivation", formData.motivation?.join(","));
      form.append("causes", formData.causes?.join(","));

      // 🔹 Experience
      form.append("org", formData.org);
      form.append("duration2", formData.duration2);
      form.append("role2", formData.role2);

      // 🔹 File
      if (formData.cv) {
        form.append("cv", formData.cv);
      }

      // 🔥 API Call
      const res = await fetch(`${api_url}/api/v1/icsaj/create/volunteer`, {
        method: "POST",
        body: form,
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("✅ Form Submitted Successfully!");
        console.log(data);
      } else {
        toast.error("❌ Error: " + data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("❌ Something went wrong");
    }
  };

  return (
    <PageLayout
      title="Volunteer With Us"
      desc="Be a part of a meaningful initiative and contribute towards justice, awareness, and advocacy."
    >
      {/* <div className="advocacy-content"> */}
      {/* <p>
        At ICSAJ (International Council of Sanatan Advocacy & Justice), we
        believe that real change is driven by dedicated individuals who are
        willing to contribute their time, knowledge, and efforts for a larger
        cause. Our volunteer program is designed to bring together passionate
        individuals who want to make a meaningful impact in the field of legal
        awareness, advocacy, and social responsibility.
      </p>

      <p>
        Volunteering with ICSAJ provides an opportunity to work alongside
        experienced professionals, gain practical exposure, and contribute to
        initiatives that promote justice and awareness. Whether you are a law
        student, professional, or someone interested in social work, your
        participation can create a positive impact.
      </p> */}

      <div className="container my-5">
        <div className="form-card p-4 shadow">
          <h2 className="text-center mb-4">Volunteer Registration Form</h2>

          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* BASIC INFO */}
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  className="form-control"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <input
                  type="email"
                  name="email"
                  placeholder="Email ID"
                  className="form-control"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  className="form-control"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  name="location"
                  placeholder="Current Location"
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 mb-3">
                <textarea
                  name="address"
                  placeholder="Address"
                  className="form-control"
                  onChange={handleChange}
                ></textarea>
              </div>

              {/* ROLE */}
              <div className="col-12 mb-3">
                <label>I am a</label>
                <select
                  name="role"
                  className="form-control"
                  onChange={handleChange}
                >
                  <option>School Student</option>
                  <option>College Student</option>
                  <option>Working Professional</option>
                  <option>Home Maker</option>
                  <option>Retired Individual</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="col-12 mb-3">
                <input
                  type="text"
                  name="qualification"
                  placeholder="Qualification"
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 mb-3">
                <input
                  type="text"
                  name="linkedin"
                  placeholder="LinkedIn Profile Link"
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              {/* AVAILABILITY */}
              <div className="col-12 mb-3">
                <label>I can volunteer</label>
                <select
                  name="availability"
                  className="form-control"
                  onChange={handleChange}
                >
                  <option>Only on weekends</option>
                  <option>Only on weekdays</option>
                  <option>Flexibly</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="col-12 mb-3">
                <label>Duration</label>
                <select
                  name="duration"
                  className="form-control"
                  onChange={handleChange}
                >
                  <option>For a day</option>
                  <option>Up to one week</option>
                  <option>1-3 months</option>
                  <option>More than 3 months</option>
                </select>
              </div>

              {/* PREFERENCE */}
              <div className="col-12 mb-3">
                <label>Preferred Activity</label>
                <select
                  name="activity"
                  className="form-control"
                  onChange={handleChange}
                >
                  <option>Interact with many people</option>
                  <option>Work individually</option>
                  <option>Not sure</option>
                </select>
              </div>

              <div className="col-12 mb-3">
                <label>Personality</label>
                <select
                  name="personality"
                  className="form-control"
                  onChange={handleChange}
                >
                  <option>Extrovert</option>
                  <option>Introvert</option>
                  <option>Not sure</option>
                </select>
              </div>

              {/* MOTIVATION (Checkbox) */}
              <div className="col-12 mb-3">
                <label>Motivation (Select up to 3)</label>
                {[
                  "Share my skills",
                  "Learn new skills",
                  "Meet like-minded people",
                  "Give back to community",
                  "Use time meaningfully",
                ].map((item) => (
                  <div key={item}>
                    <input
                      type="checkbox"
                      name="motivation"
                      value={item}
                      checked={formData.motivation.includes(item)}
                      onChange={handleChange}
                    />{" "}
                    {item}
                  </div>
                ))}
              </div>

              {/* CAUSES */}
              <div className="col-12 mb-3">
                <label>Interested Causes (max 3)</label>
                {[
                  "Education",
                  "Health",
                  "Environment",
                  "Gender",
                  "Elder Care",
                ].map((item) => (
                  <div key={item}>
                    <input
                      type="checkbox"
                      name="causes"
                      value="Education"
                      checked={formData.causes.includes("Education")}
                      onChange={handleChange}
                    />{" "}
                    {item}
                  </div>
                ))}
              </div>

              {/* EXPERIENCE */}
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  name="org"
                  placeholder="Organization Name"
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3 mb-3">
                <input
                  type="text"
                  name="duration2"
                  placeholder="Duration"
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-3 mb-3">
                <input
                  type="text"
                  name="role2"
                  placeholder="Role"
                  className="form-control"
                  onChange={handleChange}
                />
              </div>

              {/* FILE */}
              <div className="col-12 mb-3">
                <label>Upload CV</label>
                <input
                  type="file"
                  name="cv"
                  className="form-control"
                  onChange={handleChange}
                  accept=".pdf"
                />
              </div>
            </div>

            <button className="btn btn-danger w-100 mt-3">
              Submit Application
            </button>
          </form>
        </div>
      </div>
      {/* </div> */}
    </PageLayout>
  );
}
